export default {
  areas: {
    hero: {
      eyebrow: 'Area di servizio',
      title: 'Telecamere e allarmi in tutta la regione Reno-Meno',
      subtitle: 'Da Francoforte passando per Offenbach, Hanau e Darmstadt fino a Groß-Gerau: SSG Signaltechnik pianifica, installa e gestisce videosorveglianza e allarmi per privati e aziende, di persona e sul posto.',
      ctaPrimary: 'Richiedi una prima consulenza gratuita',
      ctaSecondary: 'Scopri la videosorveglianza',
    },
    breadcrumbHome: 'Home',
    breadcrumbCurrent: 'Area di servizio',
    intro: {
      eyebrow: 'Dove siamo attivi per te',
      title: 'Distanze brevi in tutta la regione',
      p1: 'La nostra azienda di sicurezza ha sede a Hainburg e si muove rapidamente in tutta la regione Reno-Meno. Telecamera, videosorveglianza o allarme: veniamo da te, analizziamo l’immobile e installiamo tutto in modo pulito e professionale.',
      p2: 'Casa privata, condominio, negozio, ufficio, magazzino o officina: gestiamo progetti di ogni dimensione a Francoforte, Offenbach, Hanau, Darmstadt, Groß-Gerau e comuni limitrofi.',
    },
    city: 'Città',
    district: 'Circondario',
    coverage: {
      eyebrow: 'Radicati sul territorio',
      title: 'Il tuo specialista della regione, per la regione',
      p1: 'Come azienda locale della regione Reno-Meno conosciamo esigenze e condizioni del luogo. Per la tua telecamera o allarme: distanze brevi, contatti personali e appuntamenti rapidi.',
      p2: 'Ci muoviamo anche oltre la regione Reno-Meno su accordo. Contattaci e verificheremo cosa è possibile per il tuo progetto.',
      ctaPrimary: 'Richiedi ora',
      ctaSecondary: 'Scopri i sistemi di allarme',
      caption: 'Montaggio e configurazione personale sul posto, da Hainburg in tutta la regione Reno-Meno.',
    },
    cta: {
      title: 'Telecamera o allarme per il tuo immobile?',
      lead: 'Ti consigliamo senza impegno e ti mostriamo la soluzione adatta al tuo immobile e budget, in tutta la regione Reno-Meno.',
      primary: 'Richiedi una prima consulenza gratuita',
      secondary: 'Avvia il pianificatore di telecamere',
    },
  },
};